import { render } from "./time-swap.view.vue?vue&type=template&id=f0547302&scoped=true&ts=true"
import script from "./time-swap.view.vue?vue&type=script&lang=ts"
export * from "./time-swap.view.vue?vue&type=script&lang=ts"

import "./time-swap.view.vue?vue&type=style&index=0&id=f0547302&lang=scss&scoped=true"

import exportComponent from "/agent/_work/1/s/Customer/onlinekiosk_vue_js/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f0547302"]])

export default __exports__